import profile_placeholder from '../../assets/images/pages/profile_placeholder.png'
import { Fragment } from "react";
import { Link, useMatch } from "react-router-dom";
import henceforthApi, { CURRENCY_SYMBOL } from "../../utils/henceforthApi";
import { numberWithCommas } from "../../utils/validations";
import OrderStatus from "../order/OrderStatus";
import COPY from "../../../src/assets/images/copy.png"
import SignedImage from "../SignedImage";


export default (res: any) => <tr>
    < td>{Number(res?.page) == 0
        ? res.index + 1
        : (Number(res.page) - 1) * res.limit + (res.index + 1)}{console.log(res)}
    </td>
    <td >{res.order_id} <img src={COPY} style={{ width: 15 }} onClick={() => res.copyText(res.order_id, "OrderId")} role="button" data-toggle="tooltip" title={res.order_id} /></td>

    <td className='product-image-table'>
        <div className="d-flex align-items-center gap-2">
            <SignedImage 
                src={res.customer_detail?.profile_pic || res.user_info?.profile_pic || ""}
                fallback={profile_placeholder}
                alt="user" 
                className='rounded-circle' 
                size="small"
                height="40"
                width="40"
            />
            <div>
                <p className="fw-bold mb-0">{res.customer_detail?.name || res.user_info?.name || "Not Available"}</p>
                {/* <small className="text-muted">ID: {res.customer_detail?._id || res.user_id?._id || "N/A"}</small> */}
            </div>
        </div>
    </td>
    <td>
        <OrderStatus {...res} />
    </td>
    <td>
        {res?.delivery_type ? res?.delivery_type : "Not Avaiable"}
    </td>
    <td>
        <strong>
            {CURRENCY_SYMBOL}{res?.price ? res?.price : res?.total_price || "0"}
        </strong>
    </td>
    
    <td>
        <div>
            <strong>{CURRENCY_SYMBOL}{res.admin_earning?.toLocaleString() || res.admin_commision?.toLocaleString() || "0"}</strong>
        </div>
    </td>
    <td>
        <div className="btn-group gap-2">
            <Link className="btn btn-white btn-sm" to={`/ordersdetails/${res._id}`}> <i className="fa fa-eye me-1"></i>View</Link>
        </div>
    </td>
</tr>